import ApiService from '../../../../../services/ApiService'
import Component from '../../../../../components/toast.vue'

export default {
  props: {
    auth: Boolean,
  },

  data: () => ({
    loading: false,
    institution: {},
    userLogged: {},
    institution: {},
    institutions: [],
    apiService: new ApiService(),
  }),

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))

    this.listInstitutions()
  },

  components: {},

  methods: {
    close() {
      if (this.auth) {
        if (this.institution.userType == 6) {
          this.$router.push('/calleds')
        } else {
          this.$router.push('/serviceOrders')
        }
      } else {
        this.$router.go(-1)
      }
    },

    async listInstitutions() {
      this.institutions = []
      this.loading = true
      await this.apiService
        .get('institution/list-with-user-type')
        .then((response) => {
          this.institutions = response.content
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },

    async listInstitutionsLiberate() {
      this.institutions = []
      this.loading = true
      await this.apiService
        .get('institution/ListUser')
        .then((response) => {
          this.institutions = response.content
        })
        .catch((err) => {})

      this.loading = false
    },

    async submit() {
      localStorage.removeItem('institution')

      this.$i18n.locale = this.institution.locale
        ? this.institution.locale
        : 'pt'
      localStorage.removeItem('locale')
      localStorage.setItem('locale', this.$i18n.locale)

      this.$store.commit(
        'SET_INSTITUTION_USER',
        JSON.stringify(this.institution)
      )

      this.$root.$emit('update')
      await this.apiService
        .get(`called/pendent-rating/${this.institution.id}`)
        .then((response) => {
          this.userLogged.pendingCalleds = response.content

          if (
            this.userLogged.pendingCalleds &&
            this.userLogged.pendingCalleds.length > 0
          ) {
            this.$toast(Component, {
              position: 'top-right',
              timeout: 10000,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: false,
              draggablePercent: 0.6,
              showCloseButtonOnHover: true,
              closeButton: 'button',
              icon: true,
              rtl: false,
            })
          }
        })

      this.close()
    },
  },

  watch: {},
}
